/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFormValues } from "../../../app/slices/applicationsSlice";
import { validate } from "validate.js";
import { addRiskSchema } from "../validationSchemas";
import { Grid, TextField, Button } from "@mui/material";
import risks from "../../../assets/static/risks.json";
import AltSelect from "../../../components/AltSelect/AltSelect";
import IconDelete from "@mui/icons-material/Delete";
import IconEdit from "@mui/icons-material/Edit";
import {
  addRisk,
  updateRisk,
  fetchRisks,
  resetStateRisks,
} from "../../../app/slices/risksSlice";
import LoadingContainer from "../../../components/loadingContainer/loadingContainer";

const RisksFragmentFragment = ({ errors: formErrors }) => {
  const { formValues } = useSelector(({ applications }) => applications);
  const { data: dataPost } = useSelector(({ risks }) => risks.post);
  const { data: dataPut } = useSelector(({ risks }) => risks.put);
  const { list: listRisks, status: statusGet } = useSelector(
    ({ risks }) => risks.get
  );

  const [localFormValues, setLocalFormValues] = useState({});
  const [selectedRisk, setSelectedRisk] = useState(null);
  const [errors, setErrors] = useState([]);
  const [list, setList] = useState([]);
  const [rebuild, setRebuild] = useState(true);

  const dispatch = useDispatch();

  //use effects
  useEffect(() => {
    loadResources();
    return () => {
      dispatch(resetStateRisks());
    };
  }, []);

  useEffect(() => {
    if (list) {
      dispatch(
        setFormValues({
          ...formValues,
          risks: [...list],
        })
      );
    }
  }, [list]);

  useEffect(() => {
    if (listRisks?.length > 0) {
      let _list = [];
      listRisks?.forEach((row) => {
        _list.push({
          id: row?.RISK_ID,
          risk: row?.RISK,
          mitigationMeasure: row?.MEASURE,
        });
      });
      setList(_list);
    } else {
      setList([]);
    }
  }, [listRisks]);

  useEffect(() => {
    if (dataPost || dataPut) {
      loadResources();
      setLocalFormValues({});
      setRebuild(false);
      setTimeout(() => {
        setRebuild(true);
      }, 400);
    }
  }, [dataPost, dataPut]);

  //methods
  const handleChange = (e) => {
    let inputName = e?.target?.name;
    let inputValue = e?.target?.value;

    setLocalFormValues({
      ...localFormValues,
      [inputName]: inputValue,
    });
  };

  const handleAddRow = () => {
    let _errors = validate(localFormValues, addRiskSchema);

    if (_errors) {
      setErrors(_errors);
      return;
    } else {
      setErrors([]);
    }

    dispatch(
      addRisk({
        APPLICATION_ID: formValues?.applicationId,
        RISK: localFormValues?.risk,
        MEASURE: localFormValues?.mitigationMeasure,
      })
    );
  };

  const handleRemoveRow = (index) => {
    dispatch(
      updateRisk({
        id: list[index]?.id,
        payload: {
          STATUS: "I",
        },
      })
    );
  };

  const handleUpdateRow = () => {
    let _errors = validate(localFormValues, addRiskSchema);

    if (_errors) {
      setErrors(_errors);
      return;
    } else {
      setErrors([]);
    }

    dispatch(
      updateRisk({
        id: selectedRisk?.id,
        payload: {
          APPLICATION_ID: formValues?.applicationId,
          RISK: localFormValues?.risk,
          MEASURE: localFormValues?.mitigationMeasure,
        },
      })
    );
  };

  const loadResources = () => {
    dispatch(resetStateRisks());
    dispatch(
      fetchRisks({
        APPLICATION_ID: formValues?.applicationId,
        STATUS: "A",
      })
    );
  };

  //builders
  const BuildForm = () => {
    return (
      <div
        style={{
          background: "#f1f1f1",
          padding: "10px 20px",
          borderRadius: "10px",
          margin: "20px 0",
        }}
      >
        <Grid container>
          <Grid item xs={12} md={12} className="padded-grid-item">
            <b>Add Risk & Mitigation Measure</b>
          </Grid>
          <Grid item xs={12} sm={12} md={6} className="padded-grid-item">
            {rebuild && (
              <AltSelect
                options={risks}
                formValues={localFormValues}
                onChange={handleChange}
                name={"risk"}
                errors={errors}
                label="Risk"
              />
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={12} className="padded-grid-item">
            <TextField
              key={"input-mitigation-measures"}
              required
              fullWidth
              multiline
              minRows={3}
              maxRows={3}
              margin="dense"
              autoComplete="new-password"
              variant="outlined"
              error={errors["mitigationMeasure"] ? true : false}
              helperText={
                errors["mitigationMeasure"] ? errors.mitigationMeasure[0] : null
              }
              name="mitigationMeasure"
              id="mitigationMeasures"
              label="Mitigation Measures"
              onChange={handleChange}
              value={localFormValues?.mitigationMeasure || ""}
            />
          </Grid>
          <Grid item xs={12} md={12} className="padded-grid-item">
            <div className="flex-row justify-content-end ">
              {selectedRisk && (
                <Button
                  variant="contained"
                  onClick={() => {
                    setSelectedRisk(null);
                    setLocalFormValues({});
                    setRebuild(false);
                    setTimeout(() => {
                      setRebuild(true);
                    }, 400);
                  }}
                  margin="dense"
                  size="medium"
                  color="secondary"
                  // disabled={getButtonDisabledStatus()}
                  style={{ textTransform: "unset", margin: "0 5px" }}
                >
                  Cancel
                </Button>
              )}
              <Button
                variant="contained"
                onClick={selectedRisk ? handleUpdateRow : handleAddRow}
                margin="dense"
                size="medium"
                color="secondary"
                // disabled={getButtonDisabledStatus()}
                style={{ textTransform: "unset" }}
              >
                {selectedRisk === null ? "+ Add" : "Update"}
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };

  const BuildTable = () => {
    return (
      <table className="stakeholders-table">
        <thead>
          <th>S/N</th>
          <th>Risk</th>
          <th>Mitigation Measure</th>
          <th>Edit</th>
          <th>Delete</th>
        </thead>
        <tbody>
          {list?.length === 0 && (
            <tr>
              <td colSpan={5} className="text-align-center text-muted">
                No risks added
              </td>
            </tr>
          )}
          {list?.length > 0 && (
            <>
              {list?.map((row, index) => (
                <tr>
                  <td className="td-50 text-align-center">{index + 1}</td>
                  <td>{row?.risk}</td>
                  <td>{row?.mitigationMeasure}</td>
                  <td className="td-50 edit-icon">
                    <div className="flex-row justify-content-center">
                      <IconEdit
                        onClick={() => {
                          setSelectedRisk(row);
                          setLocalFormValues({
                            risk: row?.risk,
                            mitigationMeasure: row?.mitigationMeasure,
                          });
                          setRebuild(false);
                          setTimeout(() => {
                            setRebuild(true);
                          }, 400);
                        }}
                      />
                    </div>
                  </td>
                  <td className="td-50 delete-icon">
                    <div className="flex-row justify-content-center">
                      <IconDelete
                        onClick={() => {
                          if (
                            window.confirm(
                              "Are you sure you want to remove this row?"
                            )
                          ) {
                            handleRemoveRow(index);
                          }
                        }}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </>
          )}
        </tbody>
      </table>
    );
  };

  return (
    <div className="app-padding">
      <h2 className="mb-10">Risks</h2>
      {BuildForm()}
      {BuildTable()}
      {formErrors?.risks && (
        <div className="flex-row mb-10 mt-20 align-items-center">
          <div className="list-bullet mr-10"></div>
          <div className="text-red">{formErrors?.risks?.[0]}</div>
        </div>
      )}
    </div>
  );
};

export default RisksFragmentFragment;
